import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import {AiFillGithub, AiOutlineTwitter, AiFillInstagram, AiFillFacebook} from "react-icons/ai";
import {FaLinkedinIn} from "react-icons/fa";

function Footer() {
  return (<Container fluid="fluid" className="footer">
    <Row>
      <Col md={12} className="home-about-social">
        <ul className="home-about-social-links">
          <li className="social-icons">
            <a href="https://github.com/Amshra267" target="_blank" rel="noreferrer" className="icon-colour  home-social-icons">
              <AiFillGithub/>
            </a>
          </li>
          <li className="social-icons">
            <a href="https://twitter.com/Amshra267" target="_blank" rel="noreferrer" className="icon-colour  home-social-icons">
              <AiOutlineTwitter/>
            </a>
          </li>
          <li className="social-icons">
            <a href="https://www.linkedin.com/in/aman-mishra-a0b7881aa" target="_blank" rel="noreferrer" className="icon-colour  home-social-icons">
              <FaLinkedinIn/>
            </a>
          </li>
          <li className="social-icons">
            <a href="https://www.instagram.com/amanmishra1909/" target="_blank" rel="noreferrer" className="icon-colour home-social-icons">
              <AiFillInstagram/>
            </a>
          </li>
          <li className="social-icons">
            <a href="https://www.facebook.com/Amshra267" target="_blank" rel="noreferrer" className="icon-colour home-social-icons">
              <AiFillFacebook/>
            </a>
          </li>
        </ul>
      </Col>
    </Row>
  </Container>);
}

export default Footer;